/**
 * @module OpacitySliderControl
 */
import "./OpacitySliderControl.css";
import Control from 'ol/control/Control';
import { applyStyle } from 'ol-mapbox-style';
import { getLayerByName } from '../utils/getLayerByName.js';
import { t } from '../utils/i18n';

class OpacitySliderControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Create the container div
    const container = document.createElement('div');
    container.className = 'nhc-map-opacity-slider border-top border-gray-10 padding-y-1 padding-x-2';

    container.innerHTML = `
      <h4 class="padding-bottom-0">${t("control_opacity_slider_label")}</h4>
      <form class="usa-form">
        <input id="usa-range" class="usa-range" type="range" min="0" max="0.5" step="0.05" value="0" />
      </form>
    `;

    super({
      element: container,
      target: options.target
    });

    this.map = options.map;
    this.productId = options.productId;
    this.layerId = options.layerId;
    this.styleModule = options.styleModule;
    this.style = null;

    // Find the layer by ID
    //this.layer = this.map.getLayers().getArray().find(l => l.get('id') === this.layerId);

    const stylePath = `/maps/${this.productId}/styles/`;
    const styleFile = `${this.styleModule}.json`;
    const stylePathFile = `${stylePath}${styleFile}`;
    fetch(stylePathFile)
      .then(res => res.json())
      .then(styleObj => {
        this.style = styleObj;
        //applyStyle(this.layer, this.style, this.layerId);
      });

    // Bind and add the event handler
    const slider = container.querySelector('#usa-range');
    slider.addEventListener('input', this.handleSliderInput.bind(this));
  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
    // Find element with the nhc-map-opacity-slider class
    const section = document.querySelector(`.nhc-map-opacity-slider`);
    // Get the h4 element and change it's contents
    if (!section) return; // If the section doesn't exist, nothing to update
    const heading = section.querySelector('h4');
    if (heading) {
      heading.textContent = t("control_opacity_slider_label");
    }
  }

  /**
   * Handle slider input event to update layer opacity
   * @param {object} e - The event object from the slider input
   * @returns 
   */
  async handleSliderInput(e) {
    const opacity = parseFloat(e.target.value);
    const layer = getLayerByName(this.map, this.layerId);
    if (!this.style || !layer) return;

    // Deep clone the style object to avoid mutation issues
    const styleClone = JSON.parse(JSON.stringify(this.style));

    // Update fill-opacity in the style object
    styleClone.layers.forEach(styleLayer => {
      if (styleLayer.id === this.layerId) {
        styleLayer.paint = styleLayer.paint || {};
        styleLayer.paint['fill-opacity'] = opacity;
      }
    });

    // Re-apply the style
    await applyStyle(layer, styleClone, this.layerId);
  }

}

export default OpacitySliderControl;